import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '../_services/translate.service';

@Pipe({
    name: 'translate',
    pure: false
})
export class TranslatePipe implements PipeTransform {

    constructor(private translate: TranslateService) { }

    transform(key: string): string {
        return this.translate.data[key] || key;
    }

}


// WEBPACK FOOTER //
// ./ClientApp/app/pipes/translate.pipe.ts